import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, Transition as _Transition, resolveComponent as _resolveComponent } from "vue"

import AppPreloader from "./components/ThePreloader.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_component_RouterView, null, {
    default: _withCtx(({ Component, route }) => [
      (_openBlock(), _createBlock(_Transition, {
        mode: "out-in",
        duration: 300,
        key: route.path
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_Suspense, { timeout: "0" }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            fallback: _withCtx(() => [
              _createVNode(AppPreloader)
            ]),
            _: 2
          }, 1024))
        ]),
        _: 2
      }, 1024))
    ]),
    _: 1
  }))
}
}

})